/* eslint-disable no-unused-vars */
export enum TradeType {
  RFQ = "RFQ",
  Order = "Order",
  NotSent = "Not Sent",
}
